import React, { useState } from "react";
import { X, Send } from "react-feather";
import agentActivityService from "../../../services/agentActivityService";
import { success, error as notifyError } from "../../../utils/notification";

interface IRequestQuoteModalProps {
    isOpen: boolean;
    onClose: () => void;
    activityId: string;
    supplierEmail: string;
    supplierName: string;
    onSuccess: (updatedActivity: any) => void;
}

const RequestQuoteModal: React.FC<IRequestQuoteModalProps> = ({
    isOpen,
    onClose,
    activityId,
    supplierEmail,
    supplierName,
    onSuccess
}) => {
    const [ingredient, setIngredient] = useState("");
    const [quantity, setQuantity] = useState<number>(0);
    const [unit, setUnit] = useState("kg");
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await agentActivityService.requestQuote({
                activity_id: activityId,
                supplier_email: supplierEmail,
                supplier_name: supplierName,
                ingredient,
                quantity,
                unit
            });
            success("Quote request sent successfully!");
            onSuccess(response.data);
            onClose();
        } catch (err) {
            const error = err as any;
            console.error("Failed to request quote:", error);
            notifyError(error.response?.data?.message || "Failed to request quote. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content quote-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Request Quote</h2>
                    <button className="close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="form-group">
                            <label>Ingredient</label>
                            <input
                                type="text"
                                value={ingredient}
                                onChange={(e) => setIngredient(e.target.value)}
                                placeholder="e.g. Blueberry Powder"
                                required
                                className="form-control"
                            />
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Quantity</label>
                                <input
                                    type="number"
                                    value={quantity}
                                    onChange={(e) => setQuantity(Number(e.target.value))}
                                    required
                                    className="form-control"
                                    min="1"
                                />
                            </div>
                            <div className="form-group">
                                <label>Unit</label>
                                <select
                                    value={unit}
                                    onChange={(e) => setUnit(e.target.value)}
                                    className="form-control"
                                >
                                    <option value="kg">kg</option>
                                    <option value="lb">lb</option>
                                    <option value="mt">mt</option>
                                    <option value="g">g</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? "Sending..." : "Send Request"}
                            {!loading && <Send size={16} style={{ marginLeft: 8 }} />}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RequestQuoteModal;
